import React, {createContext} from 'react';

export type PricePoint = 1.99 | 4.99 | 3.49 | null;

export type WatchFaceContextType = {
  appId: string;
  appName: string;
  priceUsd: PricePoint;
};

export const WatchFaceContext = createContext<WatchFaceContextType>({
  appId: 'NOT_SET',
  appName: 'NOT_SET',
  priceUsd: null,
});

type WatchFaceContextProviderProps = {
  children: React.ReactNode;
  value: WatchFaceContextType;
};

export function WatchFaceContextProvider({
  children,
  value,
}: WatchFaceContextProviderProps) {
  return (
    <WatchFaceContext.Provider value={value}>
      {children}
    </WatchFaceContext.Provider>
  );
}
